import React from 'react';
import { BRAND } from '../../data/mock';
import { Button } from '../ui/button';
import { ArrowRight, TrendingUp } from 'lucide-react';

export const VetCostsSection = () => {
  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Medical Costs Infographic */}
          <div className="relative">
            <div className="rounded-3xl overflow-hidden shadow-2xl border border-slate-100">
              <img
                src="https://customer-assets.emergentagent.com/job_petcover-broker/artifacts/a5b00186_unnamed%20%281%29.png"
                alt="The Price of Paws - Pet Medical Costs Infographic"
                className="w-full h-auto"
              />
            </div>
          </div>

          {/* Content */}
          <div>
            <div className="inline-flex items-center gap-2 bg-red-50 text-red-600 rounded-full px-4 py-2 mb-6">
              <TrendingUp className="w-5 h-5" />
              <span className="font-semibold text-sm">Vet Costs Are Rising</span>
            </div>
            
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-slate-900 mb-6">
              Can You Afford an Unexpected Vet Bill?
            </h2>
            
            <p className="text-lg text-slate-600 mb-6 leading-relaxed">
              The average pet owner faces thousands of dollars in unexpected veterinary expenses. 
              From ear infections to emergency surgeries, costs add up quickly — and they're only going up.
            </p>

            <ul className="space-y-3 mb-8">
              <li className="flex items-center gap-3 text-slate-700">
                <span className="w-2 h-2 rounded-full bg-red-500" />
                Ingesting foreign objects can cost over <strong>$5,000</strong>
              </li>
              <li className="flex items-center gap-3 text-slate-700">
                <span className="w-2 h-2 rounded-full bg-red-500" />
                Non-cancerous skin mass removal: <strong>$801</strong>
              </li>
              <li className="flex items-center gap-3 text-slate-700">
                <span className="w-2 h-2 rounded-full bg-red-500" />
                Dental disease treatment: <strong>$702</strong>
              </li>
            </ul>
            
            <Button
              asChild
              size="lg"
              className="text-white font-bold shadow-lg shadow-orange-500/25"
              style={{ background: 'linear-gradient(135deg, #f97316 0%, #fb7185 100%)' }}
            >
              <a href={BRAND.quoteUrl} target="_blank" rel="noopener noreferrer">
                Protect Your Pet Today
                <ArrowRight className="w-5 h-5 ml-2" />
              </a>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};
